import { Component, EventEmitter, Output, Input, signal, WritableSignal, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {MatTabsModule} from '@angular/material/tabs';
import { inject, computed } from '@angular/core';
import { PermissionService } from '../../services/security/permission.service';

@Component({
    selector: 'app-modal-settings',
    imports: [
        CommonModule,
        DialogModule,
        FontAwesomeModule,
        MatTabsModule
    ],
    templateUrl: './modal-settings.component.html',
    styleUrl: './modal-settings.component.scss'
})
export class ModalSettingsComponent {
  private permission = inject(PermissionService);

  constructor() {
  }

  @Input() isVisible!: WritableSignal<boolean>;
  @Output() close = new EventEmitter<void>();

  usersSettingsComp: any = null;
  permissionsSettingsComp: any = null;

  hasOpenedUsers = signal(false);
  hasOpenedPermissions = signal(false);
  activeTabIndex = signal(0);
  isLoadingUsers = signal(false);
  isLoadingPermissions = signal(false);

  get isSuperAdmin(): boolean {
    try {
      const raw = localStorage.getItem('roleId');
      return raw ? Number(raw) === 4 : false;
    } catch { return false; }
  }

  canViewUsersTab = computed(() => this.permission.can('settings:users'));
  canViewPermissionsTab = computed(() => this.permission.can('settings:permissions'));

  async onTabChange(index: number): Promise<void> {
    if (!this.isVisible()) {
      return;
    }
    
    this.activeTabIndex.set(index);
    if (index === 0 && this.canViewUsersTab() && !this.hasOpenedUsers()) {
      this.isLoadingUsers.set(true);
      const { UsersSettingsComponent } = await import('./users-settings/users-settings.component');
      this.usersSettingsComp = UsersSettingsComponent;
      this.hasOpenedUsers.set(true);
      this.isLoadingUsers.set(false);
    } else if (index === 1 && this.canViewPermissionsTab() && !this.hasOpenedPermissions()) {
      this.isLoadingPermissions.set(true);
      const { PermissionsSettingsComponent } = await import('./permissions-settings/permissions-settings.component');
      this.permissionsSettingsComp = PermissionsSettingsComponent;
      this.hasOpenedPermissions.set(true);
      this.isLoadingPermissions.set(false);
    }
  }

  async onShowModal(): Promise<void> {
    if (this.canViewUsersTab() && !this.hasOpenedUsers()) {
      this.isLoadingUsers.set(true);
      const { UsersSettingsComponent } = await import('./users-settings/users-settings.component');
      this.usersSettingsComp = UsersSettingsComponent;
      this.hasOpenedUsers.set(true);
      this.isLoadingUsers.set(false);
    } else if (this.canViewPermissionsTab() && !this.hasOpenedPermissions()) {
      this.isLoadingPermissions.set(true);
      const { PermissionsSettingsComponent } = await import('./permissions-settings/permissions-settings.component');
      this.permissionsSettingsComp = PermissionsSettingsComponent;
      this.hasOpenedPermissions.set(true);
      this.isLoadingPermissions.set(false);
    }
  }

  onCloseModal() {
    this.isVisible.set(false);
    this.close.emit();
  }
}
